import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Project({ title, date, body, image, isLeft }) {
  const [isDispSmall, setDispSmall] = useState(window.innerWidth < 768);
  useEffect(() => {
    const updateSize = () => {
      // Check if the scroll position is past 120px or if window width is less than 800px
      if (window.innerWidth < 768) {
        setDispSmall(true); // Show if scroll position is past the threshold or if window width is less than 800px
      } else {
        setDispSmall(false); // Hide if scroll position is above the threshold and window width is 800px or greater
      }
    };

    // Attach the event listener on mount
    window.addEventListener("resize", updateSize); // Listen to window resize events as well

    // Cleanup the event listener on unmount
    return () => {
      window.removeEventListener("resize", updateSize); // Cleanup resize listener
    };
  }, []);
  return (
    <>
      <div className="w-1/2 md:w-0 border-t-2 md:border-0 m-auto rounded-full" />
      <motion.section
        className="min-h-[50vh] flex justify-center items-center md:border-y-4 rounded-3xl md:border-opacity-35 md:border-white md:m-16 m-4 bg-black bg-opacity-20"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      >
        <motion.div
          className="flex flex-col md:flex-row items-center justify-between px-8 md:p-[4vw]"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          {!isLeft && !isDispSmall && (
            <>
              <div className="w-full md:w-2/3 pr-0 md:pr-[8vw] md:pl-[4vw] text-center md:text-left">
                <h2 className="text-xl md:text-3xl mb-4 nsans-7-bo text-white">
                  {title}
                </h2>
                <h2 className="text-sm md:text-me mb-4 nsans-7-eli text-white">
                  {date}
                </h2>
                <p className="text-sm md:text-lg leading-snug nsans-7-li text-white text-justify">
                  {body}
                </p>
              </div>

              <div className="w-3/4 md:w-1/2 mb-6 md:mb-0 pr-0 md:pr-[4vw] opacity-100">
                <motion.img
                  src={image}
                  alt={title}
                  className="w-full h-auto rounded-lg shadow-lg nsans-7-eli opacity-100 z-10 border-2 border-white"
                  whileHover={{
                    scale: 1.1,
                  }}
                  transition={{ type: "spring", stiffness: 70 }}
                />
              </div>
            </>
          )}
          {(isLeft || isDispSmall) && (
            <>
              <div className="w-full md:w-1/2 mb-8 md:mb-0 mt-8 md:mt-0 pl-0 md:pl-[3vw] opacity-100">
                <motion.img
                  src={image}
                  alt={title}
                  className="w-full h-auto rounded-lg shadow-lg nsans-7-eli opacity-100 z-10 border-2 border-white"
                  whileHover={{
                    scale: 1.1,
                  }}
                  transition={{ type: "spring", stiffness: 70 }}
                />
              </div>
              <div className="w-full md:w-2/3 pl-0 md:pl-[6vw] text-center md:text-left">
                <h2 className="text-xl md:text-3xl mb-4 nsans-7-bo text-white">
                  {title}
                </h2>
                <h2 className="text-sm md:text-me mb-4 nsans-7-eli text-white">
                  {date}
                </h2>
                <p className="text-sm md:text-lg leading-tight nsans-7-li text-white pb-12 md:pb-0 text-justify">
                  {body}
                </p>
              </div>
            </>
          )}
        </motion.div>
      </motion.section>
      <div className="w-1/2 md:w-0 border-t-2 md:border-0 m-auto rounded-full" />
    </>
  );
}
